import React, { useRef, useEffect, useState } from "react";
import { Button } from "reactstrap";

const CustomWebcam = ({ onCapture, clear }) => {
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const [capturedImage, setCapturedImage] = useState(null);
  const [isCameraOn, setIsCameraOn] = useState(false);

  const startCamera = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });
      if (videoRef.current) {
        videoRef.current.srcObject = stream;
        setIsCameraOn(true);
      }
    } catch (err) {
      console.error("Camera access error:", err);
    }
  };

  const stopCamera = () => {
    const stream = videoRef.current?.srcObject;
    if (stream) {
      stream.getTracks().forEach((track) => track.stop());
    }
    setIsCameraOn(false);
  };

  const capture = () => {
    const video = videoRef.current;
    const canvas = canvasRef.current;

    if (video && canvas) {
      const ctx = canvas.getContext("2d");
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

      const imageData = canvas.toDataURL("image/jpeg");
      setCapturedImage(imageData);
      onCapture?.(imageData);
      stopCamera();
    }
  };

  const retake = () => {
    setCapturedImage(null);
    clear("");
    startCamera();
  };

  useEffect(() => {
    let isMounted = true;

    const initCamera = async () => {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: true,
        });
        if (isMounted && videoRef.current) {
          videoRef.current.srcObject = stream;
          setIsCameraOn(true);
        }
      } catch (err) {
        console.error("Camera access error:", err);
      }
    };

    initCamera();

    return () => {
      isMounted = false;
      stopCamera();
    };
  }, []);

  return (
    <div
      style={{
        textAlign: "center",
        marginBottom: "10px",
        position: "relative",
      }}
    >
      {!capturedImage ? (
        <div style={{ position: "relative", width: "100%" }}>
          <video
            ref={videoRef}
            style={{ width: "100%", zIndex: 1 }}
            playsInline
            autoPlay
            muted
            onCanPlay={() => {
              if (videoRef.current) {
                videoRef.current.play().catch((err) => {
                  console.error("Video play error:", err);
                });
              }
            }}
          />
          <canvas ref={canvasRef} style={{ display: "none" }} />
          <div style={{ marginTop: "10px", zIndex: 3 }}>
            {isCameraOn && (
              <Button color="primary" type="button" onClick={capture}>
                Capture Photo
              </Button>
            )}
            {!isCameraOn && (
              <Button color="secondary" type="button" onClick={startCamera}>
                Turn On Camera
              </Button>
            )}
          </div>
        </div>
      ) : (
        <>
          <img src={capturedImage} alt="Captured" style={{ width: "100%" }} />
          <Button color="primary" type="button" onClick={retake}>
            Retake Photo
          </Button>
        </>
      )}
    </div>
  );
};

export default CustomWebcam;
